/* tslint:disable */
/* eslint-disable */
/**
 * SENGO Platform Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.27
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EventStatus } from '../model';
// @ts-ignore
import type { NoShowCheckInsFilter } from '../model';
// @ts-ignore
import type { PaginatedEventCreatedResponse } from '../model';
// @ts-ignore
import type { PaginatedEventParticipatedResponse } from '../model';
// @ts-ignore
import type { SearchUsersResponse } from '../model';
// @ts-ignore
import type { UserBanStatus } from '../model';
// @ts-ignore
import type { UserDeactivationStatus } from '../model';
// @ts-ignore
import type { UserDetailsResponse } from '../model';
// @ts-ignore
import type { UserRegistrationRequest } from '../model';
// @ts-ignore
import type { UserUpdateRequest } from '../model';
/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Register a new user of the platform (creator/participant)
         * @param {UserRegistrationRequest} userRegistrationRequest Basic info of the user to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRegisterUser: async (userRegistrationRequest: UserRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegistrationRequest' is not null or undefined
            assertParamExists('adminRegisterUser', 'userRegistrationRequest', userRegistrationRequest)
            const localVarPath = `/admin/user/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/admin/user/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete the profile image of a User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserProfileImage: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserProfileImage', 'userId', userId)
            const localVarPath = `/admin/user/{userId}/profile-img`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple users
         * @param {Array<string>} [userIdArray] Array of IDs of users to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsers: async (userIdArray?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userIdArray) {
                localVarQueryParameter['userIdArray'] = userIdArray;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve all the information on the user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/admin/user/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve events a user has created
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of users
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEventsCreated: async (userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserEventsCreated', 'userId', userId)
            const localVarPath = `/admin/user/{userId}/events/created`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (noShowCheckIns) {
                localVarQueryParameter['noShowCheckIns'] = noShowCheckIns;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve events a user has participated in
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of users
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEventsReserved: async (userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserEventsReserved', 'userId', userId)
            const localVarPath = `/admin/user/{userId}/events/reserved`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (noShowCheckIns) {
                localVarQueryParameter['noShowCheckIns'] = noShowCheckIns;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send the password reset link to a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('resetUserPassword', 'userId', userId)
            const localVarPath = `/admin/user/{userId}/password/reset`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for users based on user criteria including status, birthday, name, username and IDs
         * @param {string} [queryString] Query string to match against user name, username and user Id
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<string>} [status] List of status to filter the search of users
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers: async (queryString?: string, startDate?: string, endDate?: string, status?: Array<string>, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (queryString !== undefined) {
                localVarQueryParameter['queryString'] = queryString;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ban or unban a user
         * @param {string} userId 
         * @param {UserBanStatus} userBanStatus Ban status of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserBanStatus: async (userId: string, userBanStatus: UserBanStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('setUserBanStatus', 'userId', userId)
            // verify required parameter 'userBanStatus' is not null or undefined
            assertParamExists('setUserBanStatus', 'userBanStatus', userBanStatus)
            const localVarPath = `/admin/user/{userId}/ban`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userBanStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivate or reactivate a user
         * @param {string} userId 
         * @param {UserDeactivationStatus} userDeactivationStatus Ban status of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserDeactivationStatus: async (userId: string, userDeactivationStatus: UserDeactivationStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('setUserDeactivationStatus', 'userId', userId)
            // verify required parameter 'userDeactivationStatus' is not null or undefined
            assertParamExists('setUserDeactivationStatus', 'userDeactivationStatus', userDeactivationStatus)
            const localVarPath = `/admin/user/{userId}/deactivation`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDeactivationStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user profile
         * @param {string} userId 
         * @param {UserUpdateRequest} userUpdateRequest Updated user profile data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userId: string, userUpdateRequest: UserUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'userUpdateRequest' is not null or undefined
            assertParamExists('updateUser', 'userUpdateRequest', userUpdateRequest)
            const localVarPath = `/admin/user/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Register a new user of the platform (creator/participant)
         * @param {UserRegistrationRequest} userRegistrationRequest Basic info of the user to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminRegisterUser(userRegistrationRequest: UserRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminRegisterUser(userRegistrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.adminRegisterUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete the profile image of a User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserProfileImage(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserProfileImage(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteUserProfileImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple users
         * @param {Array<string>} [userIdArray] Array of IDs of users to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsers(userIdArray?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsers(userIdArray, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.deleteUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve all the information on the user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve events a user has created
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of users
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserEventsCreated(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventCreatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserEventsCreated(userId, startDate, endDate, status, page, pageSize, noShowCheckIns, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserEventsCreated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve events a user has participated in
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of users
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserEventsReserved(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedEventParticipatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserEventsReserved(userId, startDate, endDate, status, page, pageSize, noShowCheckIns, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserEventsReserved']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send the password reset link to a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetUserPassword(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetUserPassword(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.resetUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search for users based on user criteria including status, birthday, name, username and IDs
         * @param {string} [queryString] Query string to match against user name, username and user Id
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<string>} [status] List of status to filter the search of users
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUsers(queryString?: string, startDate?: string, endDate?: string, status?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUsers(queryString, startDate, endDate, status, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.searchUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ban or unban a user
         * @param {string} userId 
         * @param {UserBanStatus} userBanStatus Ban status of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserBanStatus(userId: string, userBanStatus: UserBanStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserBanStatus(userId, userBanStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.setUserBanStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deactivate or reactivate a user
         * @param {string} userId 
         * @param {UserDeactivationStatus} userDeactivationStatus Ban status of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setUserDeactivationStatus(userId: string, userDeactivationStatus: UserDeactivationStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setUserDeactivationStatus(userId, userDeactivationStatus, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.setUserDeactivationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user profile
         * @param {string} userId 
         * @param {UserUpdateRequest} userUpdateRequest Updated user profile data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userId: string, userUpdateRequest: UserUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userId, userUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Register a new user of the platform (creator/participant)
         * @param {UserRegistrationRequest} userRegistrationRequest Basic info of the user to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRegisterUser(userRegistrationRequest: UserRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminRegisterUser(userRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete the profile image of a User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserProfileImage(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUserProfileImage(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple users
         * @param {Array<string>} [userIdArray] Array of IDs of users to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsers(userIdArray?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUsers(userIdArray, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve all the information on the user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsResponse> {
            return localVarFp.getUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve events a user has created
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of users
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEventsCreated(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedEventCreatedResponse> {
            return localVarFp.getUserEventsCreated(userId, startDate, endDate, status, page, pageSize, noShowCheckIns, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve events a user has participated in
         * @param {string} userId 
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<EventStatus>} [status] List of status to filter the search of users
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEventsReserved(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedEventParticipatedResponse> {
            return localVarFp.getUserEventsReserved(userId, startDate, endDate, status, page, pageSize, noShowCheckIns, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send the password reset link to a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserPassword(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetUserPassword(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for users based on user criteria including status, birthday, name, username and IDs
         * @param {string} [queryString] Query string to match against user name, username and user Id
         * @param {string} [startDate] Starting date (included) to search for birthday of the users
         * @param {string} [endDate] Ending date (included) to search for user birthday
         * @param {Array<string>} [status] List of status to filter the search of users
         * @param {number} [page] Page number for pagination
         * @param {number} [pageSize] Number of events per page for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers(queryString?: string, startDate?: string, endDate?: string, status?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<SearchUsersResponse> {
            return localVarFp.searchUsers(queryString, startDate, endDate, status, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ban or unban a user
         * @param {string} userId 
         * @param {UserBanStatus} userBanStatus Ban status of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserBanStatus(userId: string, userBanStatus: UserBanStatus, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setUserBanStatus(userId, userBanStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivate or reactivate a user
         * @param {string} userId 
         * @param {UserDeactivationStatus} userDeactivationStatus Ban status of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setUserDeactivationStatus(userId: string, userDeactivationStatus: UserDeactivationStatus, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setUserDeactivationStatus(userId, userDeactivationStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user profile
         * @param {string} userId 
         * @param {UserUpdateRequest} userUpdateRequest Updated user profile data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userId: string, userUpdateRequest: UserUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsResponse> {
            return localVarFp.updateUser(userId, userUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - interface
 */
export interface UsersApiInterface {
    /**
     * 
     * @summary Register a new user of the platform (creator/participant)
     * @param {UserRegistrationRequest} userRegistrationRequest Basic info of the user to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminRegisterUser(userRegistrationRequest: UserRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete an User
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete the profile image of a User
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUserProfileImage(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete multiple users
     * @param {Array<string>} [userIdArray] Array of IDs of users to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUsers(userIdArray?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Retrieve all the information on the user
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsResponse>;

    /**
     * 
     * @summary Retrieve events a user has created
     * @param {string} userId 
     * @param {string} [startDate] Starting date (included) to search for birthday of the users
     * @param {string} [endDate] Ending date (included) to search for user birthday
     * @param {Array<EventStatus>} [status] List of status to filter the search of users
     * @param {number} [page] Page number for pagination
     * @param {number} [pageSize] Number of events per page for pagination
     * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserEventsCreated(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedEventCreatedResponse>;

    /**
     * 
     * @summary Retrieve events a user has participated in
     * @param {string} userId 
     * @param {string} [startDate] Starting date (included) to search for birthday of the users
     * @param {string} [endDate] Ending date (included) to search for user birthday
     * @param {Array<EventStatus>} [status] List of status to filter the search of users
     * @param {number} [page] Page number for pagination
     * @param {number} [pageSize] Number of events per page for pagination
     * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserEventsReserved(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedEventParticipatedResponse>;

    /**
     * 
     * @summary Send the password reset link to a user
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetUserPassword(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Search for users based on user criteria including status, birthday, name, username and IDs
     * @param {string} [queryString] Query string to match against user name, username and user Id
     * @param {string} [startDate] Starting date (included) to search for birthday of the users
     * @param {string} [endDate] Ending date (included) to search for user birthday
     * @param {Array<string>} [status] List of status to filter the search of users
     * @param {number} [page] Page number for pagination
     * @param {number} [pageSize] Number of events per page for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchUsers(queryString?: string, startDate?: string, endDate?: string, status?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<SearchUsersResponse>;

    /**
     * 
     * @summary Ban or unban a user
     * @param {string} userId 
     * @param {UserBanStatus} userBanStatus Ban status of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setUserBanStatus(userId: string, userBanStatus: UserBanStatus, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Deactivate or reactivate a user
     * @param {string} userId 
     * @param {UserDeactivationStatus} userDeactivationStatus Ban status of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setUserDeactivationStatus(userId: string, userDeactivationStatus: UserDeactivationStatus, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update user profile
     * @param {string} userId 
     * @param {UserUpdateRequest} userUpdateRequest Updated user profile data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(userId: string, userUpdateRequest: UserUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsResponse>;

}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI implements UsersApiInterface {
    /**
     * 
     * @summary Register a new user of the platform (creator/participant)
     * @param {UserRegistrationRequest} userRegistrationRequest Basic info of the user to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminRegisterUser(userRegistrationRequest: UserRegistrationRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).adminRegisterUser(userRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an User
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUser(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete the profile image of a User
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUserProfileImage(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUserProfileImage(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple users
     * @param {Array<string>} [userIdArray] Array of IDs of users to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteUsers(userIdArray?: Array<string>, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUsers(userIdArray, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve all the information on the user
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUser(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve events a user has created
     * @param {string} userId 
     * @param {string} [startDate] Starting date (included) to search for birthday of the users
     * @param {string} [endDate] Ending date (included) to search for user birthday
     * @param {Array<EventStatus>} [status] List of status to filter the search of users
     * @param {number} [page] Page number for pagination
     * @param {number} [pageSize] Number of events per page for pagination
     * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserEventsCreated(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserEventsCreated(userId, startDate, endDate, status, page, pageSize, noShowCheckIns, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve events a user has participated in
     * @param {string} userId 
     * @param {string} [startDate] Starting date (included) to search for birthday of the users
     * @param {string} [endDate] Ending date (included) to search for user birthday
     * @param {Array<EventStatus>} [status] List of status to filter the search of users
     * @param {number} [page] Page number for pagination
     * @param {number} [pageSize] Number of events per page for pagination
     * @param {Array<NoShowCheckInsFilter>} [noShowCheckIns] Creator-no-show categories included alongside selected statuses; none means zero, some means positive, unknown means null
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserEventsReserved(userId: string, startDate?: string, endDate?: string, status?: Array<EventStatus>, page?: number, pageSize?: number, noShowCheckIns?: Array<NoShowCheckInsFilter>, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserEventsReserved(userId, startDate, endDate, status, page, pageSize, noShowCheckIns, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send the password reset link to a user
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resetUserPassword(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).resetUserPassword(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for users based on user criteria including status, birthday, name, username and IDs
     * @param {string} [queryString] Query string to match against user name, username and user Id
     * @param {string} [startDate] Starting date (included) to search for birthday of the users
     * @param {string} [endDate] Ending date (included) to search for user birthday
     * @param {Array<string>} [status] List of status to filter the search of users
     * @param {number} [page] Page number for pagination
     * @param {number} [pageSize] Number of events per page for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUsers(queryString?: string, startDate?: string, endDate?: string, status?: Array<string>, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).searchUsers(queryString, startDate, endDate, status, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ban or unban a user
     * @param {string} userId 
     * @param {UserBanStatus} userBanStatus Ban status of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setUserBanStatus(userId: string, userBanStatus: UserBanStatus, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).setUserBanStatus(userId, userBanStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivate or reactivate a user
     * @param {string} userId 
     * @param {UserDeactivationStatus} userDeactivationStatus Ban status of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setUserDeactivationStatus(userId: string, userDeactivationStatus: UserDeactivationStatus, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).setUserDeactivationStatus(userId, userDeactivationStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user profile
     * @param {string} userId 
     * @param {UserUpdateRequest} userUpdateRequest Updated user profile data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUser(userId: string, userUpdateRequest: UserUpdateRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUser(userId, userUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

